export default "__VITE_ASSET__SwWBhm1$__"